import { FormGroup, FormControl } from '@angular/forms';

// Helper function for handling file uploads
export function handleFileUploaded(
  fileDetails: { file: File; readableUrl: string } | null,
  formGroup: FormGroup,
  controlName: string
): void {
  const formControl = formGroup.get(controlName) as FormControl;
  if (fileDetails) {
    formControl.setValue(fileDetails);
    formGroup.markAsDirty()
  } else {

  }
}

// Helper function for handling file upload errors
export function handleFileUploadError(
  errorResponse: any,
  formGroup: FormGroup,
  controlName: string
): void {
  const formControl = formGroup.get(controlName) as FormControl;
  formControl.setErrors(errorResponse.errorObject);
  formControl.markAsTouched()

  console.error('File upload error', errorResponse);
}
